export default "__VITE_ASSET__DRJynHAZ__"